module.exports = __webpack_public_path__ + "0f9cbae74cb3dad9d75a7e96cf7f4a30.pdf";